import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useRestoreEngineeringJudgementMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useEJLogContext } from '../../../../EJLogContext'
import { EngineeringJudgement } from '../../../../EJLogContext/types'

export function useRestore(): RestoreRowActionOptions<EngineeringJudgement> {
  const { refetch } = useEJLogContext()
  const [restore] = useRestoreEngineeringJudgementMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreEngineeringJudgement: {
        judgement: { formattedNumber },
      },
    }) => simpleRestoreNotification(formattedNumber),
  })
  return {
    permission: Permission.RemoveRestoreEngineeringJudgement,
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
  }
}
